<app-loader-spinner></app-loader-spinner>
<router-outlet></router-outlet>
<!-- < ng - toast /> -->
<ng-toast [width]="300" [position]="ToasterPosition.TOP_RIGHT" />
<!-- <app-cookie-consent></app-cookie-consent> -->
